import { errorMsg } from '../../utils/errorMsg';
import React, { useState, useEffect } from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField,
  FormControl, InputLabel, Select, MenuItem, Alert, CircularProgress,
  Box, Typography, FormControlLabel, Checkbox
} from '@mui/material';
import { criarInscricao } from '../../api/cursos';
import api from '../../axios';

function InscricaoModal({ open, onClose, cursoId, onSuccess }) {
  const [membros, setMembros] = useState([]);
  const [isExterno, setIsExterno] = useState(false);
  const [saving, setSaving] = useState(false);
  const [erro, setErro] = useState('');
  const [form, setForm] = useState({
    membro_id: '',
    nome_externo: '',
    email_externo: '',
    telefone_externo: ''
  });

  useEffect(() => {
    if (open) {
      setErro('');
      setForm({ membro_id: '', nome_externo: '', email_externo: '', telefone_externo: '' });
      setIsExterno(false);
      api.get('/secretaria/membros')
        .then(res => setMembros(res.data))
        .catch(() => setMembros([]));
    }
  }, [open]);

  const handleChange = (field) => (e) => {
    setForm(f => ({ ...f, [field]: e.target.value }));
  };

  const handleSalvar = async () => {
    if (!isExterno && !form.membro_id) { setErro('Selecione um membro.'); return; }
    if (isExterno && !form.nome_externo.trim()) { setErro('Nome do externo é obrigatório.'); return; }
    setSaving(true);
    setErro('');
    try {
      const payload = isExterno
        ? { nome: form.nome_externo, email: form.email_externo, telefone: form.telefone_externo, externo: true }
        : { membro_id: parseInt(form.membro_id, 10) };
      await criarInscricao(cursoId, payload);
      onSuccess();
      onClose();
    } catch (err) {
      setErro(errorMsg(err) || 'Erro ao realizar inscrição');
    }
    setSaving(false);
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Nova Inscrição</DialogTitle>
      <DialogContent sx={{ display: 'flex', flexDirection: 'column', gap: 2, pt: 2 }}>
        {erro && <Alert severity="error">{erro}</Alert>}

        <FormControlLabel
          control={<Checkbox checked={isExterno} onChange={e => setIsExterno(e.target.checked)} />}
          label="Inscrição de externo (não membro)"
        />

        {isExterno ? (
          <>
            <TextField label="Nome *" value={form.nome_externo} onChange={handleChange('nome_externo')} fullWidth />
            <TextField label="Email" value={form.email_externo} onChange={handleChange('email_externo')} fullWidth />
            <TextField label="Telefone" value={form.telefone_externo} onChange={handleChange('telefone_externo')} fullWidth />
          </>
        ) : (
          <FormControl fullWidth>
            <InputLabel>Membro *</InputLabel>
            <Select value={form.membro_id} label="Membro *" onChange={handleChange('membro_id')}>
              <MenuItem value="">Selecione um membro</MenuItem>
              {membros.map(m => (
                <MenuItem key={m.id} value={m.id}>{m.nome}</MenuItem>
              ))}
            </Select>
          </FormControl>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancelar</Button>
        <Button onClick={handleSalvar} variant="contained" disabled={saving}>
          {saving ? <CircularProgress size={18} /> : 'Inscrever'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default InscricaoModal;
